import {FAILURE, PENDING, SUCCESS} from '../constants'
import {getReservationItemDetails as getReservationItemDetailsAPI} from '../../services/reservationItem'

export async function getReservationItemDetails(dispatch, {group_id, uid}) {
  try {
    dispatch({type: PENDING})

    let response = await getReservationItemDetailsAPI({group_id, uid})

    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Reservation Item Details Failed: ${uid}`)
    dispatch({type: FAILURE, payload: e})
  }
}
